import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchLatestBroadcastsAPI } from '../services/serverService';

export default function LatestBroadcastsPage() {
    const navigate = useNavigate();
    const [broadcasts, setBroadcasts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadBroadcasts = async () => {
            try {
                const response = await fetchLatestBroadcastsAPI();
                if (response.data?.success) setBroadcasts(response.data.data);
            } catch (error) {
                console.error("Failed to load broadcasts:", error);
            } finally {
                setLoading(false);
            }
        };
        loadBroadcasts();
    }, []);

    const formatTime = (timeObj) => {
        if (!timeObj) return 'Unknown Time';
        const seconds = timeObj._seconds || timeObj.seconds;
        if (!seconds) return 'Unknown Time';
        return new Date(seconds * 1000).toLocaleString();
    };

    if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Aggregating Global Broadcasts...</div>;

    return (
        <div style={{ padding: '40px', backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                <button onClick={() => navigate('/dashboard')} style={{ marginRight: '20px', padding: '8px 16px', border: '1px solid #ddd', borderRadius: '4px', background: 'white', cursor: 'pointer' }}>← Dashboard</button>
                <div>
                    <h1 style={{ margin: 0, fontSize: '24px', color: '#2b6cb0' }}>Global Broadcast History</h1>
                    <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>Broadcast from every active server.</p>
                </div>
            </div>

            <div style={{ display: 'grid', gap: '15px' }}>
                {broadcasts.length === 0 ? <div style={{ color: '#718096' }}>No broadcasts found on the platform.</div> : 
                    broadcasts.map(broadcast => (
                        <div key={broadcast.id || broadcast.sendAt} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', borderLeft: '4px solid #3182ce', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ flex: 1 }}>
                                    <h3 style={{ margin: '0 0 5px 0', color: '#2d3748' }}>{broadcast.title || 'Broadcast'}</h3>
                                    <div style={{ color: '#4a5568', fontSize: '15px', marginBottom: '10px', backgroundColor: '#f7fafc', padding: '10px', borderRadius: '6px' }}>
                                        {broadcast.message}
                                    </div>
                                    
                                    <div style={{ color: '#718096', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <span>Sent by: <strong>{broadcast.createdBy}</strong></span>
                                        
                                        {/* Hover Tooltip Logic */}
                                        <span 
                                            title={broadcast.serverIds.join(', ')} 
                                            style={{ cursor: 'help', borderBottom: '1px dotted #718096' }}
                                        >
                                            Targeted: <strong>{broadcast.serverIds.length} Server(s)</strong>
                                        </span>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right', marginLeft: '20px' }}>
                                    <span style={{ fontSize: '12px', color: '#a0aec0', background: '#f7fafc', padding: '4px 8px', borderRadius: '4px' }}>
                                        {formatTime(broadcast.sendAt)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}